import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/api";
import * as CryptoJS from "crypto-js";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    loggedIn: false,
    user: JSON.parse(localStorage.getItem("userCredential")) ?? {},
    loading: false,
    error: null,
    userSetting: JSON.parse(localStorage.getItem("userSetting")) ?? {},
    userSettingData: JSON.parse(localStorage.getItem("userSettingData")) ?? {},
    forgotPasswordSuccess: null,
    linkValidated: false,
    resetToken: null,
    resetPasswordSuccess: null,
  },
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loggedIn = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
      localStorage.setItem("userCredential", JSON.stringify(action.payload));
      let dateUTC = new Date(action.payload.expiration);
      let dateIST = new Date(dateUTC);
      dateIST.setHours(dateIST.getHours() + 5);
      dateIST.setMinutes(dateIST.getMinutes() + 30);
      const newDate = new Date(dateIST);
      localStorage.setItem("userSession", JSON.stringify(newDate.getTime()));
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.user = null;
      state.loading = false;
      state.userSetting = null;
      state.userSettingData = null;
      localStorage.removeItem("userCredential");
      localStorage.removeItem("userSetting");
      localStorage.removeItem("userSettingData");
      localStorage.removeItem("userSession");
      localStorage.removeItem("navMenu");
    },
    logout: (state) => {
      state.loggedIn = false;
      state.user = null;
      state.loading = false;
      state.error = null;
      state.userSetting = null;
      state.userSettingData = null;
      localStorage.removeItem("userCredential");
      localStorage.removeItem("userSetting");
      localStorage.removeItem("userSettingData");
      localStorage.removeItem("userSession");
      localStorage.removeItem("navMenu");
    },
    userSetting: (state, action) => {
      state.userSetting = action.payload;
      localStorage.setItem("userSetting", JSON.stringify(action.payload));
    },
    userSettingData: (state, action) => {
      state.userSettingData = action.payload;
      localStorage.setItem("userSettingData", JSON.stringify(action.payload));
    },
    forgotPasswordStart: (state) => {
      state.loading = true;
      state.error = null;
      state.forgotPasswordSuccess = null;
    },

    forgotPasswordSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.forgotPasswordSuccess = action.payload;
    },

    forgotPasswordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.forgotPasswordSuccess = null;
    },
    verifyLinkStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    verifyLinkSuccess: (state, action) => {
      state.loading = false;
      state.linkValidated = true;
      state.resetToken = action.payload;
    },

    verifyLinkFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.linkValidated = false;
    },
    resetPasswordStart: (state) => {
      state.loading = true;
      state.error = null;
      state.resetPasswordSuccess = null;
    },

    resetPasswordSuccess: (state, action) => {
      state.loading = false;
      state.resetPasswordSuccess = action.payload;
    },

    resetPasswordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  userSetting,
  userSettingData,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  verifyLinkStart,
  verifyLinkSuccess,
  verifyLinkFailure,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  clearErrors,
} = userSlice.actions;

export const loginUser = (credentials) => async (dispatch) => {
  dispatch(loginStart());
  try {
    let headers = {
      "Content-Type": "application/json;",
    };
    const response = await postRequest("account/Login", credentials, headers);

    if (response.data.Payload) {
      headers["Authorization"] = `Bearer ${response.data.Payload.token}`;
      const userSettingApi = await postRequest(
        "User/GetUserCurrStateSettings",
        { userId: response.data.Payload.Id },
        headers,
      );

      if (userSettingApi.data.Payload.length === 0) {
        dispatch(
          loginFailure(
            "User Permission not found Please contact Administrator",
          ),
        );
        return;
      }

      dispatch(userSetting(userSettingApi.data.Payload));
      //dispatch(getUserserSetting({token: response.data.Payload.token, Id: response.data.Payload.Id}));
      const userSettingDataApi = await postRequest(
        "User/GetUserMasterPgData",
        { userId: response.data.Payload.Id },
        headers,
      );
      dispatch(userSettingData(userSettingDataApi.data.Payload));
      //dispatch(getUserserSettingData({token: response.data.Payload.token, Id: response.data.Payload.Id}));

      dispatch(loginSuccess(response.data.Payload));
    } else {
      dispatch(loginFailure(response.data.Message));
    }
  } catch (error) {
    dispatch(loginFailure(error.response.data));
  }
};

export const forgotPassword = (username) => async (dispatch) => {
  dispatch(forgotPasswordStart());

  try {
    const headers = {
      "Content-Type": "application/json;",
    };

    const response = await postRequest(
      "account/SendPRLink",
      { username },
      headers,
    );

    if (response.data.Status === 1) {
      dispatch(forgotPasswordSuccess(response.data.Message));
    } else {
      dispatch(
        forgotPasswordFailure(
          response.data.Message || "Unable to send reset link.",
        ),
      );
    }
  } catch (error) {
    dispatch(
      forgotPasswordFailure(
        error?.response?.data?.Message ||
          error?.response?.data ||
          "Something went wrong.",
      ),
    );
  }
};

export const verifyPRLink = (id) => async (dispatch) => {
  dispatch(verifyLinkStart());

  try {
    const headers = {
      "Content-Type": "application/json;",
    };

    const response = await postRequest(
      "account/VerifyPRLink",
      { Id: id },
      headers,
    );

    if (response.data.Status === 1) {
      dispatch(verifyLinkSuccess(response.data.Payload.token));
    } else {
      dispatch(verifyLinkFailure(response.data.Message));
    }
  } catch (error) {
    dispatch(
      verifyLinkFailure(
        error?.response?.data?.Message || "Invalid or expired link.",
      ),
    );
  }
};

export const resetPassword =
  ({ token, password }) =>
  async (dispatch) => {
    dispatch(resetPasswordStart());

    try {
      const key = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");

      const iv = CryptoJS.enc.Utf8.parse("bwplAPVp1OH7Xzyr");

      const encryptedPwd = CryptoJS.AES.encrypt(password, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const headers = {
        "Content-Type": "application/json;",
      };

      const response = await postRequest(
        "account/SetNewPassword",
        {
          token,
          newPassword: encryptedPwd.toString(),
        },
        headers,
      );

      if (response.data.Status === 1) {
        dispatch(resetPasswordSuccess(response.data.Message));
      } else {
        dispatch(resetPasswordFailure(response.data.Message));
      }
    } catch (error) {
      dispatch(
        resetPasswordFailure(
          error?.response?.data?.Message || "Failed to reset password.",
        ),
      );
    }
  };

export const saveUserSetting = (payload) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json;",
    Authorization: `Bearer ${payload.token}`,
  };

  let obj = {
    userId: payload.userId,
    currCustomer: payload.currCustomer,
    currWarehouse: payload.currWarehouse,
  };
  const response = await postRequest(
    "User/SaveUserCurrStateSettings",
    obj,
    headers,
  );

  if (response.data.Payload) {
    dispatch(
      userSetting([
        {
          currCustomer: payload.currCustomer,
          currWarehouse: payload.currWarehouse,
        },
      ]),
    );
  }
};

export const getUserserSetting = (payload) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json;",
    Authorization: `Bearer ${payload.token}`,
  };

  const userSettingApi = await postRequest(
    "User/GetUserCurrStateSettings",
    { userId: payload.Id },
    headers,
  );
  dispatch(userSetting(userSettingApi.data.Payload));
};

export const getUserserSettingData = (payload) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json;",
    Authorization: `Bearer ${payload.token}`,
  };

  const userSettingDataApi = await postRequest(
    "User/GetUserMasterPgData",
    { userId: payload.Id },
    headers,
  );
  dispatch(userSettingData(userSettingDataApi.data.Payload));
};

export default userSlice.reducer;
